export default [
  {
    path: '/politica-seguranca',
    name: 'politica-seguranca',
    component: () => import(/* webpackChunkName: "politica-seguranca" */ '../../views/politicaSeguranca/PoliticaSeguranca')
  }
]
